module.exports = __webpack_public_path__ + "static/media/website-square.d5a41b53.svg";